import { Fragment } from 'react';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';

import UserAvatar from './UserAvatar';
import { Box, ListItem } from '@mui/material';
import { useNavigate } from 'react-router';

interface ClientListProps {
  search?: string;
  clientUid?: string | null;
  clients: any[];
  
}


// ==============================|| CHAT - USER LIST ||============================== //

export default function ClientList({ clients, clientUid }: ClientListProps) {
  // const theme = useTheme();
  const navigate = useNavigate();

  return (
    <List component="nav">
      <Fragment>
          {clients.length == 0 && (
            <ListItem sx={{ pl: 1, borderRadius: 0, '&:hover': { borderRadius: 1 } }} >
              <ListItemText
                primary={
                  <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                    <Typography color="text.main" variant="caption">
                      Clients list is empty!
                    </Typography>
                  </Stack>
                }
              />
            </ListItem>
          )}
          {
            clients.map(client => {
              return (
                  <ListItemButton
                    sx={{ pl: 1, borderRadius: 0, '&:hover': { borderRadius: 1 } }}
                    onClick={() => {
                      navigate(`/clients/modify/${client?.uid}`);
                    }}
                    selected={(clientUid && clientUid == client?.uid) ? true : false}
                  >
                    <ListItemAvatar>
                      <UserAvatar url={client?.theme?.icons?.square_logo_path?.url} client={client} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                          <Box>
                            <Typography
                              variant="subtitle1"
                              color="text.dark"
                              sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                            >
                              {client?.name}
                            </Typography>
                            <Typography color='text.dark' variant="caption" textOverflow={'ellipsis'} sx={{
                                display: '-webkit-box',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 1,
                            }}>
                              {client?.description}
                            </Typography>
                          </Box>
                          {/* <Typography color={client?.isActive ? 'success' : "error"} variant="caption">
                            {client?.isActive ? 'Active': 'Inactive'}
                          </Typography> */}
                        </Stack>
                      }
                    />
                  </ListItemButton>
              )
            })
          }
          <Divider />
        </Fragment>
    </List>
  );
}
